"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import { SERVICE_PROCESS_STEPS } from "@/features/services/constants/service-page-content";
import type { Service } from "@/features/services/constants/services-data";
interface ServiceProcessSectionProps {
  service: Service;
}
export function ServiceProcessSection(t0) {
  const $ = _c(33);
  const {
    service
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      margin: "-100px"
    };
    t4 = {
      duration: 0.7,
      ease: "easeOut"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mx-auto max-w-2xl text-center"><span className="mb-3 block text-xs font-semibold tracking-[0.2em] text-primary uppercase">The Process</span><h2 className="font-heading text-[2.5rem] leading-[1.1] font-bold tracking-tight text-foreground sm:text-[3.2rem]">What Your Journey Could Look Like</h2></motion.div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6"><div className="absolute top-6 right-0 left-0 hidden h-px bg-border sm:block" />{SERVICE_PROCESS_STEPS.map(_temp)}</div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      y: 16
    };
    t8 = {
      opacity: 1,
      y: 0
    };
    t9 = {
      once: true
    };
    t10 = {
      duration: 0.6,
      delay: 0.3
    };
    $[6] = t10;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  const t11 = isOpen ? "border-primary/20 bg-primary/[0.03]" : "border-border bg-card";
  let t12;
  if ($[10] !== t11) {
    t12 = cn("mx-auto mt-16 max-w-2xl overflow-hidden rounded-2xl border transition-colors duration-300", t11);
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsOpen(_temp2);
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== service.soloStart.question) {
    t14 = <span className="font-heading text-base font-semibold text-foreground sm:text-lg">{service.soloStart.question}</span>;
    $[13] = service.soloStart.question;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = isOpen ? 180 : 0;
  let t16;
  if ($[15] !== t15) {
    t16 = {
      rotate: t15
    };
    $[15] = t15;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ChevronDown className="h-4 w-4 text-foreground" />;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t16) {
    t19 = <motion.span animate={t16} transition={t17} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted">{t18}</motion.span>;
    $[19] = t16;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== t14 || $[22] !== t19) {
    t20 = <button onClick={t13} className="flex w-full items-center justify-between gap-4 p-6 text-left outline-none">{t14}{t19}</button>;
    $[21] = t14;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== isOpen || $[25] !== service.soloStart.answer) {
    t21 = isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: [0.04, 0.62, 0.23, 0.98]
    }}><p className="px-6 pb-6 text-[15px] leading-relaxed text-muted-foreground">{service.soloStart.answer}</p></motion.div>;
    $[24] = isOpen;
    $[25] = service.soloStart.answer;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t21) {
    t22 = <AnimatePresence initial={false}>{t21}</AnimatePresence>;
    $[27] = t21;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== t12 || $[30] !== t20 || $[31] !== t22) {
    t23 = <section className="relative bg-background py-24 sm:py-32"><div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">{t5}{t6}<motion.div initial={t7} whileInView={t8} viewport={t9} transition={t10} className={t12}>{t20}{t22}</motion.div></div></section>;
    $[29] = t12;
    $[30] = t20;
    $[31] = t22;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  return t23;
}
function _temp2(prev) {
  return !prev;
}
function _temp(step, idx) {
  return <motion.div key={step.title} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-50px"
  }} transition={{
    duration: 0.6,
    delay: idx * 0.15
  }} className="relative flex flex-col items-start"><div className="relative z-10 mb-6 flex h-12 w-12 items-center justify-center rounded-full border border-primary/20 bg-background text-lg font-bold text-primary shadow-[0_4px_16px_rgba(0,0,0,0.04)]">{idx + 1}</div><h3 className="mb-3 font-heading text-lg font-bold text-foreground">{step.title}</h3><p className="text-[15px] leading-relaxed font-light text-muted-foreground">{step.description}</p></motion.div>;
}